import { upsertWebhookConfigDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const upsertWebhookConfigCallable = getCallable(
  upsertWebhookConfigDefinition,
);
